import { getPageComponent } from './lazyComponents';
import PageNotFound from 'components/pages/PageNotFound';

export const generateAllRoutesConfig = (staticRoutes, dynamicRoutes, auth, user, baseRouteUrl) => {

    // Объединяем статические + динамические маршруты
    const allRoutes = [
        ...staticRoutes.map(r => ({
            path: r.path,
            Component: getPageComponent(r.name),
            name: r.name,
            props: r.props || {}
        }))
    ];

    if (dynamicRoutes?.length) {
        dynamicRoutes.forEach(route => {
            const Component = auth && (!user?.email) && route.path !== 'price/:logout'
                ? PageNotFound
                : getPageComponent(route.name);

            const finalPath = route.name === 'Home' ? `${baseRouteUrl}/` : `${baseRouteUrl}/${route.path}`;

            if (route.name === 'Home' && allRoutes.some(r => r.name === 'Home')) return;

            allRoutes.push({
                path: finalPath,
                Component,
                name: route.name,
                props: {}
            });
        });
    }

    return allRoutes;
};
